import { StepMap } from "@/components/onboarding/components/welcome-wizard/onboarding-steps.types";
import { SystemPermissionsVoicePermissionsStep } from "./voice-permissions-step";

export const SystemPermissionsVoiceStepsMap: StepMap = {
  "system-permissions-voice-permissions": {
    id: "system-permissions-voice-permissions",
    render: props => <SystemPermissionsVoicePermissionsStep {...props} />,
  },
} as const;
